

import React, {Component} from "react";

import PageHeader from "./PageHeader/index";
import { Switch, Route,  NavLink, HashRouter, Redirect } from 'react-router-dom'
import IGV_Page from "./scenes/igv-page/IGV_Page";

import Login from "./session/Login";
import Home from "./scenes/Home";
import auth from "./session/Auth";
import Footer from "./footer/Footer";
import GPAP_Header from "./header/GPAP_Header";
import SideNavigation from "./SideNavigation/SideNavigation";


const config = window.config;

function AuthenticatedRoute({component: Component,enabled,  ...rest}) {
    return (
        <Route
            {...rest}
            render={
                (props) => (
                    auth.user.authenticated===true || !enabled
                        ? <Component {...props} {...rest} />
                        : (
                            <Redirect
                                to={{
                                    pathname: "/login",
                                    state: { from: props.location }
                                }}
                            />
                        )
                )
            } />
    )
}




class Main extends Component {


    render() {
        return (
            <React.Fragment>
                <SideNavigation/>
                <div className={"main"}>
                    <div className="myContainer">
                        <div className="navBar">
                            {/* <PageHeader/>*/}
                            <GPAP_Header/>
                        </div>
                        <div className="content">
                            <Route path='/gpap_home' component={() => {
                                window.location.href = window.location.origin;
                                return null;
                            }}/>
                            <Route exact path="/" component={Home}/>
                            <Route exact path="/type_search" component={Home}/>
                            <Route exact path="/igvgpap" component={Home}/>
                            <AuthenticatedRoute  path="/browser" component={IGV_Page} enabled={config.security}/>
                            <Route path="/login" component={Login} render={(props) => <Login {...props} auth={this.state.auth}/>}/>
                            <Route path='/gpap_home' component={() => {
                                window.location.href = window.location.origin;
                                return null;
                            }}/>
                            <Route path='/phenobrowse' component={() => {
                                window.location.href = window.location.origin + '/phenostore/#/browse/patient';
                                return null;
                            }}/>
                            <Route path='/phenostore' component={() => {
                                window.location.href = window.location.origin + '/phenostore';
                                return null;
                            }}/>
                            <Route path='/management' component={() => {
                                window.location.href = window.location.origin + '/datamanagement/#/management';
                                return null;
                            }}/>
                            <Route path='/submission' component={() => {
                                window.location.href = window.location.origin + '/datamanagement/#/submission';
                                return null;
                            }}/>
                            <Route path='/nextgpap' component={() => {
                                window.location.href = window.location.origin + '/nextgpap';
                                return null;
                            }}/>
                            <Route path='/cohortapp' component={() => {
                                window.location.href= window.location.origin + '/cohortapp';
                                return null;

                            }}/>


                        </div>
                        <div className="footer">
                            <Footer/>
                        </div>
                    </div>
                </div>
            </React.Fragment>
       )
    }
}


export default Main;